import { render, staticRenderFns } from "./AdminEditWohnung.vue?vue&type=template&id=406a4986&scoped=true&"
import script from "./AdminEditWohnung.vue?vue&type=script&lang=js&"
export * from "./AdminEditWohnung.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditWohnung.vue?vue&type=style&index=0&id=406a4986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a4986",
  null
  
)

export default component.exports